import { ViewModel } from 'view_models/view_model'
import { Patient } from 'entities/patient'
import { AddressViewModel } from './address_view_model'
import moment from 'moment'

export class PatientViewModel extends ViewModel<Patient> {
    public fullName = (): string => {
        return `${this.object.familyName} ${this.object.givenName}`
    }
    public fullNameKana = (): string => {
        return `${this.object.familyNameKana} ${this.object.givenNameKana}`
    }
    public fullNameView = (): JSX.Element => {
        return (
            <div>
                <div style={{ fontSize: 10 }}>{this.fullNameKana()}</div>
                <div>{this.fullName()}</div>
            </div>
        )
    }
    public birthdayText = (): string => {
        return this.toDateText(this.object.birthday)
    }

    public addressVm = (): AddressViewModel => {
        return new AddressViewModel(this.object.address!)
    }

    public gender = (): string => {
        if (this.object.gender === 'MALE') {
            return '男性'
        } else {
            return '女性'
        }
    }

    public readableEmail = () => {
        const split = this.object.email?.split('@')
        if (split) {
            return `${split[0].split('').join('、')}@${split[1]}`
        }
    }

    public age = () => {
        return moment().diff(moment(this.object.birthday), 'years') || '?'
    }
}
